import moment from 'moment';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Image from '../../../shared/Image';
import diamondPurpleIcon from '../../../../../images/icons/icon-diamond-purple.svg';
import Analytics from '../../../../modules/analytics';

import { BodyText, Button } from '../../../ui';
import SmartPricingAnnouncementModal from '../../smartPricing/SmartPricingAnnouncementModal';

import '../Notification.scss';
import './SmartPricingAnnouncementNotification.scss';

export const SMART_NOTIFICATION_LEARN_MORE_EVENT = 'smart_pricing_notification_learn_more_clicked';
/**
 * The NCD Announcement notification
 */
const SmartPricingAnnouncementNotification = ({ providerId }) => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = () => {
    Analytics.track(SMART_NOTIFICATION_LEARN_MORE_EVENT, {
      pro_id: { providerId },
      time: moment()
        .format(),
    });
    setOpen(true);
  };

  return (
    <button
      type="button"
      className="button-notification"
    >
      <section className="notification">
        <div className="icon">
          <Image
            source={{
              uri: diamondPurpleIcon,
              width: 32,
              height: 40,
              resizeMode: 'center',
            }}
          />
        </div>
        <section className="notification-body short-block">
          <div className="notification-text">
            <BodyText weight="bold">New!</BodyText>
            <p className="notification-indent">
              Clients want to pay more for your most popular time slots.
            </p>
            <Button
              onClick={handleClick}
            >
              Learn More
            </Button>
            {open && (
              <SmartPricingAnnouncementModal
                providerId={providerId}
                onClose={handleClose}
              />
            )}
          </div>
        </section>
      </section>
    </button>
  );
};

SmartPricingAnnouncementNotification.propTypes = {
  providerId: PropTypes.string.isRequired,
};

export default SmartPricingAnnouncementNotification;
